import React from 'react';
import { useAttendance } from '../context/AttendanceContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiX, FiMinus } = FiIcons;

const AttendanceGrid = () => {
  const { students, currentDate, markAttendance, getAttendanceForDate } = useAttendance();
  const attendanceData = getAttendanceForDate(currentDate);

  const getStatusIcon = (status) => {
    switch (status) {
      case 'present':
        return <SafeIcon icon={FiCheck} className="w-5 h-5" />;
      case 'absent':
        return <SafeIcon icon={FiX} className="w-5 h-5" />;
      default:
        return <SafeIcon icon={FiMinus} className="w-5 h-5" />;
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'present':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'absent':
        return 'bg-red-100 text-red-700 border-red-200';
      default:
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };

  const handleStatusClick = (studentId, currentStatus) => {
    let newStatus;
    switch (currentStatus) {
      case 'present':
        newStatus = 'absent';
        break;
      case 'absent':
        newStatus = undefined;
        break;
      default:
        newStatus = 'present';
        break;
    }
    markAttendance(studentId, currentDate, newStatus);
  };

  return (
    <div className="space-y-3">
      {students.map((student) => {
        const status = attendanceData[student.id];
        return (
          <div
            key={student.id}
            className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <span className="font-medium text-gray-900">{student.name}</span>
            
            <div className="flex space-x-2">
              <button
                onClick={() => markAttendance(student.id, currentDate, 'present')}
                className={`px-4 py-2 rounded-lg border-2 transition-all ${
                  status === 'present'
                    ? 'bg-green-100 text-green-700 border-green-300 shadow-sm'
                    : 'bg-white text-gray-600 border-gray-200 hover:border-green-300 hover:text-green-600'
                }`}
              >
                <SafeIcon icon={FiCheck} className="w-4 h-4" />
              </button>
              
              <button
                onClick={() => markAttendance(student.id, currentDate, 'absent')}
                className={`px-4 py-2 rounded-lg border-2 transition-all ${
                  status === 'absent'
                    ? 'bg-red-100 text-red-700 border-red-300 shadow-sm'
                    : 'bg-white text-gray-600 border-gray-200 hover:border-red-300 hover:text-red-600'
                }`}
              >
                <SafeIcon icon={FiX} className="w-4 h-4" />
              </button>

              <button
                onClick={() => markAttendance(student.id, currentDate, undefined)}
                className={`px-4 py-2 rounded-lg border-2 transition-all ${
                  !status
                    ? 'bg-gray-100 text-gray-700 border-gray-300 shadow-sm'
                    : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300'
                }`}
              >
                <SafeIcon icon={FiMinus} className="w-4 h-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AttendanceGrid;